
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/destinations/google-data-manager",
      function () {
        return require("private-next-pages/destinations/google-data-manager.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/destinations/google-data-manager"])
      });
    }
  